import React, { useState } from "react";
import Typical from "react-typical";
import Switch from "react-switch";
import TriangleAnimation from "./animations/particles/TriangleAnimation";
import BubblesAnimation from "./animations/particles/BubblesAnimation";

function Header({ sharedData }) {
  const [checked, setChecked] = useState(false);
  const [name] = useState(sharedData?.name);
  const [titles] = useState(
    sharedData?.titles.map((x) => [x.toUpperCase(), 1500]).flat()
  );

  function onThemeSwitchChange(checked) {
    setChecked({ checked });
    setTheme();
  }

  function setTheme() {
    var dataThemeAttribute = "data-theme";
    var body = document.body;
    var newTheme =
      body.getAttribute(dataThemeAttribute) === "dark" ? "light" : "dark";
    body.setAttribute(dataThemeAttribute, newTheme);
  }

  const HeaderTitleTypeAnimation = React.memo(
    () => {
      return <Typical className="title-styles" steps={titles} loop={50} />;
    },
    (props, prevProp) => true
  );

  return (
    <header
      id="home"
      // style={{ height: window.innerHeight - 140, display: "block" }}
      style={{ height: window.innerHeight, display: "block" }}
      className="p-0"
    >
      {window.innerWidth < 769 ? <BubblesAnimation /> : <TriangleAnimation />}

      <div className="row aligner" style={{ height: "100%" }}>
        <div className="col-md-12">
          <div>
            <span
              className="iconify header-icon"
              data-icon="emojione-v1:laptop-computer"
              data-inline="false"
            ></span>
            <br />
            <h1 className="mb-0">
              <Typical steps={[name]} wrapper="p" />
            </h1>
            <div className="title-container">
              <HeaderTitleTypeAnimation />
            </div>
            <Switch
              checked={checked}
              onChange={onThemeSwitchChange}
              offColor="#baaa80"
              onColor="#353535"
              className="react-switch mx-auto d-none"
              width={90}
              height={40}
              uncheckedIcon={
                <span
                  className="iconify"
                  data-icon="twemoji:owl"
                  data-inline="false"
                  style={{
                    display: "block",
                    height: "100%",
                    fontSize: 25,
                    textAlign: "end",
                    marginLeft: "20px",
                    color: "#353239",
                  }}
                ></span>
              }
              checkedIcon={
                <span
                  className="iconify"
                  data-icon="noto-v1:sun-with-face"
                  data-inline="false"
                  style={{
                    display: "block",
                    height: "100%",
                    fontSize: 25,
                    textAlign: "end",
                    marginLeft: "10px",
                    color: "#353239",
                  }}
                ></span>
              }
              id="icon-switch"
            />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
